// QuickBooks Integration API Service
import api from './api';

const BASE = '/api/v1/quickbooks';

const quickbooksApi = {
  async getStatus() {
    const response = await api.get(`${BASE}/status`);
    return response.data;
  },

  async getConnectUrl() {
    const response = await api.get(`${BASE}/connect`);
    return response.data.authorization_url;
  },

  async syncNow(monthsBack) {
    const response = await api.post(`${BASE}/sync-now`, monthsBack ? { months_back: monthsBack } : {});
    return response.data;
  },

  async disconnect() {
    const response = await api.post(`${BASE}/disconnect`);
    return response.data;
  },

  async getExpenseAccounts() {
    const response = await api.get(`${BASE}/expense-accounts`);
    return response.data;
  },

  async setCogsAccounts(accountNames) {
    const response = await api.put(`${BASE}/cogs-accounts`, { account_names: accountNames });
    return response.data;
  },
};

export default quickbooksApi;
